import containers from './containers';
import middleware from './middleware';

export default {
  containers,
  middleware,
};
